import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { body400 } from '../../theme/typo';
import { boxShadowZ4 } from '../../utils/styles.util';

interface ContainerProps {
  $width?: number;
}

export const DropdownCss = css<ContainerProps>`
  font-size: 0; /* Prevent extra padding */
  > * {
    ${body400}; /* Apply default font-size to children */
  }

  overflow: hidden;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.dropdown.color};
  background-color: ${(props) => props.theme.colors.dropdown.bg};
  outline: 1px solid ${(props) => props.theme.colors.dropdown.outline};

  ${boxShadowZ4};

  width: ${p => (p.$width ? `${p.$width}px` : 'auto')};
  max-width: calc(100vw - 10px);
`;

export const Container = styled(motion.div) <ContainerProps>`
  ${DropdownCss};
`;
